import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ProcessoService} from "../../../services/processo-service";
import {ListaProcesso} from "../../../models/lista-processo";
import {Router} from "@angular/router";
import {NovoDocumentoProcesso} from "../../../models/novo-documento-processo";
import {DocumentoProcessoService} from "../../../services/documento-processo.service";
import {Observable, of} from "rxjs";
import {Pasta} from "../../../models/pasta";
import { NovaPastaDocumentoComponent } from '../../components/nova-pasta-documento/nova-pasta-documento.component';

@Component({
    selector: 'app-novo-documento-processo',
    templateUrl: './novo.component.html',
    styleUrl: './novo.component.css',
    standalone: false
})
export class NovoComponent {
  @Input() isModal = false;
  @Output() atualizarLista = new EventEmitter();
  modalNovoDocumento = false;
  loading = true;
  formCadastrar: FormGroup;
  listaProcesso = new ListaProcesso();
  documento = new NovoDocumentoProcesso();
  formData: FormData = new FormData();
  arquivo: File;
  itensProcesso: Observable<Array<{id: number, titulo: string}>>;
  itensPasta: Observable<Array<{id: number, descricao: string}>>;
  pastas: Pasta[] = [];
  tiposDocumento = [
    { id: '0', descricao: 'Petição' }
  ];

  @ViewChild(NovaPastaDocumentoComponent) novaPastaModal: NovaPastaDocumentoComponent;

  constructor(private formBuilder: FormBuilder,
              private documentoService: DocumentoProcessoService,
              private processoService: ProcessoService,
              private router: Router,
              private toastr: ToastrService) {
    this.construirFormulario();
  }

  voltar(){
    if (this.isModal) {
      this.fecharModal();
    } else {
      this.router.navigateByUrl('/juridico/documento-processo');
    }
  }

  showModalNovoDocumento(){
    this.modalNovoDocumento = true;
    this.loading = false;
  }

  abrirModalNovaPasta(){
    if (!this.formCadastrar?.value?.processo) {
      this.toastr.warning('Selecione um processo antes de criar uma pasta.');
      return;
    }
    this.novaPastaModal?.abrir();
  }

  fecharModal(){
    this.modalNovoDocumento = false;
  }

  salvar(){
    this.validarFormulario();
    this.preencherModelo();
    if(this.formCadastrar.invalid){
      this.toastr.error("Formulário inválido, verifique os campos");
      return;
    }
    Swal.fire({
      title: 'Deseja realmente salvar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if(result.isConfirmed){
        this.loading = true;
        this.preencherModelo();
        console.log(this.documento)
        this.documentoService.adicionar(this.formData).subscribe({
          next: (response) => {
            this.loading = false;

            if (response.sucesso) {
              this.toastr.success("Documento salvo com sucesso");
              if (this.isModal) {
                this.atualizarLista.emit();
                this.fecharModal();
              } else {
                this.router.navigateByUrl('/juridico/documento-processo');
              }
            } else {
              this.toastr.error("Error saving document - " + response.errors[0].mensagem);
            }
          },
          error: (error) => {
            this.loading = false;
            if(error.status === 500){
              this.toastr.error(error.error);
            }
            this.toastr.error(error.erros[0].mensagem);
          }
        });
      }
    });
  }

  getArquivo(event: any) {
    if (event.target.files.length > 0) {
      this.arquivo = event.target.files[0];
    }
  }

  private preencherModelo(){
    this.formData = new FormData();
    if (this.arquivo) {
      this.formData.append('file', this.arquivo);
    }
    this.formData.append('tipo', this.formCadastrar.controls['tipo'].value ?? null);
    this.formData.append('processo', this.formCadastrar.controls['processo'].value ?? null);
    this.formData.append('pasta', this.formCadastrar.controls['pasta'].value ?? null);
    this.formData.append('descricao',this.formCadastrar.controls['descricao'].value);
    this.documento.caminho = "";
    this.documento.arquivo = this.formCadastrar.controls['arquivo'].value;
    this.documento.tipo = this.formCadastrar.controls['tipo'].value ?? null;
    this.documento.processo = this.formCadastrar.controls['processo'].value ?? null;
    this.documento.pasta = this.formCadastrar.controls['pasta'].value ?? null;
    this.documento.descricao = this.formCadastrar.controls['descricao'].value;
  }


  private getProcesso(lista: any[]): Observable<Array<{id: number, titulo: string}>> {
    return of(lista).pipe();
  }

  private getPasta(lista: any[]): Observable<Array<{id: number, descricao: string}>> {
    return of(lista).pipe();
  }

  private validarFormulario(){
    Object.keys(this.formCadastrar.controls).forEach(name => {
      const control = this.formCadastrar.controls[name];
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    });
  }

  private construirFormulario(): void {
    this.formCadastrar = this.formBuilder.group({
      descricao: ['', Validators.required],
      tipo: [null, Validators.required],
      processo: [null, Validators.required],
      pasta: [null, Validators.required],
      arquivo: ['', Validators.required]
    });
    this.loading = false;
    this.listarProcessos();
    this.listarPastas();
  }

  private listarProcessos(){
    this.processoService.selecionarLista().subscribe(response => {
      if (response.sucesso) {
        this.listaProcesso = response.dados;
        this.itensProcesso = this.getProcesso(response.dados.itens);
      } else {
        this.toastr.error(response.errors[0].mensagem);
      }
    }, error => {
      this.toastr.error('A lista de processo está vazia.');
    });
  }

  listarPastas(){
    this.documentoService.listarPastasDocumento().subscribe(response => {
      if (response.sucesso) {
        this.pastas = response.dados as unknown as Pasta[];
        // Alguns endpoints podem retornar diretamente o array ou dentro de um objeto; usando cast simples
        const itens = Array.isArray(response.dados) ? response.dados : (response.dados?.itens ?? []);
        this.itensPasta = this.getPasta(itens);
      } else {
        this.toastr.error(response.errors?.[0]?.mensagem || 'Erro ao carregar pastas.');
      }
    }, _ => this.toastr.error('Erro ao carregar pastas.'));
  }
}
